import { AppPageHeader, DefaultRouteTabs } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import React, { useEffect, useState } from 'react';

import { useSupplierFormContext } from '@/components/Suppliers/SupplierFormProvider';
import {
  useSupplierCredits,
  useSupplierMutation,
} from '@/core/domain/people/Suppliers/Suppliers.hooks';
import { ListCreditsSupplierQuery } from '@/core/domain/people/Suppliers/Suppliers.types';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import SupplierCreditListFilters from '@/components/Suppliers/SupplierCreditList/SupplierCreditListFilters';
import { Button } from 'antd';
import { useIntl } from 'react-intl';
import SupplierCreditList from '@/components/Suppliers/SupplierCreditList';
import { useDebounce } from '@/hooks';
import SupplierFooter from '@/components/Suppliers/SupplierFooter';

const SupplierCreditPage: React.FC<PageProps> = ({ route }) => {
  const intl = useIntl();
  const { supplierId, disabled } = useSupplierFormContext();

  const [queryParams, setQueryParams] = useState<ListCreditsSupplierQuery>({
    order: 'ASC',
    supplierId: Number(supplierId),
  });

  const mutation = useSupplierMutation();

  useEffect(() => {
    if (supplierId) {
      mutation.mutateAsync(Number(supplierId));
    }
  }, [supplierId]);

  const queryDebounce = useDebounce(queryParams, 500);

  const { data, isLoading, fetchNextPage, hasNextPage } = useSupplierCredits({
    ...queryDebounce,
  });

  const creditSupplier = flatInfiniteData(data);

  return (
    <DefaultRouteTabs
      permissions={route.permissions}
      route={route.parent}
      baseKey={`${supplierId}`}
      basePath={`/app/registry/suppliers/${supplierId}`}
    >
      <>
        <AppPageHeader
          onSearch={(value) =>
            setQueryParams((prev) => ({ ...prev, search: value }))
          }
          extraFilters={
            <SupplierCreditListFilters
              queryParams={queryParams}
              setQueryParams={setQueryParams}
            />
          }
          headerActions={({
            isShowingFilters,
          }: {
            // eslint-disable-next-line react/no-unused-prop-types
            isShowingFilters: boolean;
          }) =>
            isShowingFilters && (
              <Button
                type="primary"
                onClick={() =>
                  setQueryParams({
                    order: 'ASC',
                    supplierId: Number(supplierId),
                  })
                }
              >
                {intl.formatMessage({ id: 'commons.clear.filters' })}
              </Button>
            )
          }
        />

        <SupplierCreditList
          creditSupplier={creditSupplier}
          isLoading={isLoading || mutation.isLoading}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          supplier={mutation.data}
        />
      </>

      <SupplierFooter disabled={disabled} />
    </DefaultRouteTabs>
  );
};

export default SupplierCreditPage;
